<template>
    <div class="summary-wrapper">
        <div class="summary-heading">
            <h6>Summary</h6>
        </div>
        <div class="summary-details">
            <h6>{{ tournamentName }}</h6>
            <p>{{ startDate }} to {{ endDate }}</p>

            <div class="format-wrapper">
                <div class="head">Format
                     <p v-if="customFormat">Custom</p>
                </div>
                <p v-if="customFormat && poolPlay">{{ poolPlay }} games round robin to seed {{ tournamentName }} {{ bracketFormat?.bracket_name }} bracket.</p>
                <p v-else-if="events && !customFormat"> {{ events.game_guarantee }} games round robin to seed {{ events.eventName }} {{ events.bracket_format?.bracket_name }} bracket.</p>

            </div>

            <div class="age-rating-allow-wrapper">
                <span class="head">Ages & Ratings Allowed</span>
                <p v-if="Array.isArray(selectedAges)">
                    {{selectedAges.map(age => age.name).join(', ')}}
                </p>

                <p v-if="Array.isArray(selectedRatings)">
                    {{selectedRatings.map(rating => rating.rate).join(', ')}}
                </p>

                <p v-if="selectedAges.length === 0 && selectedRatings.length === 0">All ages and ratings are allowed.</p>

            </div>

            <div class="age-rating-allow-wrapper">
                <div class="head">Seed Criteria
                    <p v-if="criteriaChecked">Custom</p>
                </div>

                <p v-if="criteriaChecked && selectedSeedCriteria.length">
                    {{selectedSeedCriteria.map(seed => seed.criteria_name).join(', ')}}
                </p>
                <p v-else-if="!criteriaChecked && availableEventSeedars.length">
                    {{availableEventSeedars.map(seed => seed.criteria_name).join(', ')}}
                </p>

            </div>


            <div class="age-rating-allow-wrapper">
                <p class="head">Pool(s)</p>
                <div v-if="Object.keys(computedPoolData).length">
                    <div v-for="(teams, poolName) in computedPoolData" :key="poolName">
                        <p class="mb-2">{{ poolName }}</p>
                        <p class="mb-2">{{ teams.join(', ') }}</p>
                    </div>
                </div>
            </div>

            <div class="notes-wrapper">
                <span class="head">Notes</span>
                <p>{{tournamentNotes}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddTournament",
    data() {
        return {
            // Add any reactive data properties here
        }
    },
    watch: {
        pools_data: {
            handler() {
                if (this.pools_data && this.pools_data.pools) {
                    console.log("pools array:", this.pools_data.pools);
                }
                if (this.pools_data && this.pools_data.teams) {
                    console.log("teams array:", this.pools_data.teams);
                }
            },
            deep: true
        },
        availableEventSeedars: {
            handler(newVal) {
                console.log("availableEventSeedars:", newVal);
            },
            deep: true // optional: only needed if you're watching nested changes
        },
    },
    props: {
        tournamentName: String,
        startDate: String,
        bracketFormat: {
            type: [Object, String],
        },
        poolPlay: String,
        endDate: String,
        tournamentNotes: String,
        criteriaChecked: Boolean,
        customFormat: Boolean,
        availableEventSeedars: {
            type: Array,
            default: () => []
        },
        selectedSeedCriteria: {
            type: Array,
            default: () => []
        },
        pools_data: {
            type: Object,
            default: () => ({
                pools: [],
                teams: []
            })
        },
        selectedAges: {
            type: [Array, String],
        },
        bracketFormats: {
            type: [Array, Object],
        },
        events: {
            type: [Array, Object],
        },
        selectedRatings: {
            type: [Array, String],
        }
    },
    computed: {
        computedPoolData() {
            const poolData = {};

            // Extract pools and teams
            const poolsArray = this.pools_data && this.pools_data.pools ? this.pools_data.pools : [];
            const teamsArray = this.pools_data && this.pools_data.teams ? this.pools_data.teams : [];

            if (!Array.isArray(poolsArray)) return poolData;

            // Initialize each pool
            poolsArray.forEach(pool => {
                if (pool && pool.pool_name) {
                    poolData[pool.pool_name] = [];
                }
            });

            // Assign teams by team_sr_no
            if (Array.isArray(teamsArray)) {
                // Sort teams by team_sr_no
                const sortedTeams = [...teamsArray].sort((a, b) => a.team_sr_no - b.team_sr_no);

                sortedTeams.forEach(teamEntry => {
                    if (!teamEntry) return;

                    const poolId = teamEntry.pool_id;
                    const teamName = teamEntry.team?.team_name || 'No Name';
                    const teamSrNo = teamEntry.team_sr_no || 0;

                    const pool = poolsArray.find(p => p.id === poolId);
                    if (pool && pool.pool_name) {
                        const formattedName = `#${teamSrNo} ${teamName}`;
                        poolData[pool.pool_name].push(formattedName);
                    }
                });
            }

            return poolData;
        }

    },
    mounted() {}
}
</script>